<template>
    <div v-if="form && model">
        <rkm-area
            no-margin-top
            title="filtros"
            type="fieldset"
        >
            <rkm-form
                ref="RkmForm"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="veiculosAdicionados"
                            label="Veículo"
                            show-default-option
                            text-field="descricaoVeiculo"
                            v-model="model.veiculo"
                            value-field="id"
                            default-option-text="Todos"
                            @change="handleVeiculo()"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="municipiosAdicionados"
                            label="Cidade de Destino"
                            show-default-option
                            text-field="nome"
                            v-model="model.municipio"
                            value-field="id"
                            default-option-text="Todos"
                            @change="handleMunicipio()"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="destinosAdicionados"
                            label="Local de Destino"
                            show-default-option
                            text-field="descricao"
                            v-model="model.destino"
                            value-field="id"
                            default-option-text="Todos"
                            @change="loadFields()"
                        />
                    </rkm-col>

                     <rkm-col cols="4">
                        <rkm-form-select
                            :options="motivosAdicionados"
                            label="Motivo"
                            show-default-option
                            text-field="descricao"
                            v-model="model.motivo"
                            value-field="id"
                            default-option-text="Todos"
                            @change="loadFields()"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            label="Protocolo"
                            v-model="model.protocolo"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-button
                            color="primary"
                            :label="false"
                            @click="$refs.RkmForm.validate(search)"
                        >
                            Buscar
                        </rkm-button>
                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            title="Totais"
            no-margin-top
            v-if="items.length > 0"
            class="mb-2"
        >
            <rkm-row>
                <rkm-col cols="2">
                    Paciente(s)
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalizadores.totalPaciente }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="2">
                    Acompanhante(s)
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalizadores.totalAcompanhantes }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="3">
                   Paciente(s) e acompanhante(s)
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalizadores.totalPacienteAcompanhante }}
                        </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
            v-if="items"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                        :indeterminate="indeterminate"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="items"
                :sort-compare="sortCompare"
                no-footer-sorting
                sort-by="horaAgendamento"
                v-if="items"
            >

                <template v-slot:cell(descricaoVeiculo)="row">
                    <template v-if="row.item.descricaoVeiculo === null">
                       -
                    </template>
                    <template v-else>
                        {{ row.item.descricaoVeiculo }}
                    </template>
                </template>

            </rkm-table>
        </rkm-area>

    </div>
</template>

<script>
import { mapActions } from "vuex";

import { repository, error, data, object, stringCase, file } from "@/mixins";

import moment from "moment";

export default {
    computed: {
        optionalColumns() {
            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {
            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
    },
    created() {
        this.repositories = {
            relatorioQuantitativo: this.getConectaSusRepository("transportePaciente.relatorioQuantitativo"),
            impressao: this.getConectaSusRepository('impressao.transportePaciente'),
            exportacao: this.getConectaSusRepository('exportacao.transportePaciente'),
        };
        this.load();
    },
    data() {
        return {
            form: null,
            model: {
                periodo: {
                    start: null,
                    end: null,
                },
            },
            items: [],
            selectedAll: true,
            indeterminate: true,
            totalizadores: [],
            loaded: false,
            selectedCols: [
                'municipio',
                'destino',
                'descricaoVeiculo',
                'totalPaciente',
                'quantidadePacienteAcompanhante',
                'motivoDescricao'
            ],
            columns: [
                {
                    key: "horaAgendamento",
                    label: "Data/Hora",
                    sortable: true,
                    fixed: true,
                },
                {
                    key: "descricaoVeiculo",
                    label: "Veículo",
                    sortable: true
                },
                {
                    key: "municipio",
                    label: "Cidade de Destino",
                    sortable: true
                },
                {
                    key: "destino",
                    label: "Local de Destino",
                    sortable: true
                },
                {
                    key: "motivoDescricao",
                    label: "Motivo",
                    sortable: true
                },
                {
                    key: "protocolo",
                    label: "Protocolo",
                    fixed: true
                },
                {
                    key: "totalPaciente",
                    label: "Qtde de paciente(s)",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "quantidadePacienteAcompanhante",
                    label: "Qtde de paciente(s) e acompanhante(s)",
                    class: 'col-min text-center',
                    sortable: true
                },
            ],
            veiculosAdicionados: [],
            municipiosAdicionados: [],
            destinosAdicionados: [],
            motivosAdicionados: [],
        };
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        sortCompare(a, b, key) {

            if (key === 'horaAgendamento') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        load() {
            this.setLoading();
            this.repositories.relatorioQuantitativo
                .index()
                .then(({ data }) => {
                    if (data.form) this.form = data.form;
                    if (data.model) this.model = data.model;

                    data.model.periodo.start = this.getDateObject(data.model.periodo.start)
                    data.model.periodo.end = this.getDateObject(data.model.periodo.end)

                    this.additionals = data.additionals

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        setListagem() {

            this.items = []
        },
        handleVeiculo() {

            this.model.municipio = null
            this.model.destino = null
            this.model.motivo = null
            this.loadFields()
        },
        handleMunicipio(){

            this.loadFields()
        },
        handleDestino(){

            this.loadFields()
        },
        handleMotivo(){

            this.loadFields()
        },
        loadFields() {

            this.setLoading()
            this.setListagem()

            this.repositories.relatorioQuantitativo.getLoadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadVeiculo(data.model.veiculos)
                    this.loadMunicipio(data.model.municipios)
                    this.loadDestino(data.model.destinos)
                    this.loadMotivo(data.model.motivos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadVeiculo(veiculos) {

            const veiculoCadastrado = []

            veiculos.map(veiculo => {

                const veiculoInserido = veiculoCadastrado.find(u => u.id == veiculo.id)

                if (!veiculoInserido) {

                    veiculoCadastrado.push({

                        id: veiculo.id,
                        descricaoVeiculo: veiculo.descricaoVeiculo,
                    })
                }
            })

            if (veiculoCadastrado) {

                veiculoCadastrado.sort((a,b) => (a.descricaoVeiculo > b.descricaoVeiculo) ? 1 : ((b.descricaoVeiculo > a.descricaoVeiculo) ? -1 : 0));
            }

            this.veiculosAdicionados = veiculoCadastrado

            let veiculoSelecionado = this.veiculosAdicionados.find(u => u.id == this.model.veiculo)

            if (!veiculoSelecionado) {

                this.model.veiculo = null
            }
        },
        loadMunicipio(municipios){

            const municipioCadastrado = []

            municipios.map(municipio => {

                const municipioInserido = municipioCadastrado.find(u => u.id == municipio.id)

                if (!municipioInserido) {

                    municipioCadastrado.push({

                        id: municipio.id,
                        nome: municipio.nome,
                    })
                }
            })

            if (municipioCadastrado) {

                municipioCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.municipiosAdicionados = municipioCadastrado

            let municipioSelecionado = this.municipiosAdicionados.find(u => u.id == this.model.municipio)

            if (!municipioSelecionado) {

                this.model.municipio = null
            }
        },
        loadDestino(destinos){

            const destinoCadastrado = []

            destinos.map(destino => {

                const destinoInserido = destinoCadastrado.find(u => u.id == destino.id)

                if (!destinoInserido) {

                    destinoCadastrado.push({

                        id: destino.id,
                        descricao: destino.descricao,
                    })
                }
            })

            if (destinoCadastrado) {

                destinoCadastrado.sort((a,b) => (a.descricao > b.descricao) ? 1 : ((b.descricao > a.descricao) ? -1 : 0));
            }

            this.destinosAdicionados = destinoCadastrado

            let destinoSelecionado = this.destinosAdicionados.find(u => u.id == this.model.destino)

            if (!destinoSelecionado) {

                this.model.destino = null
            }
        },
        loadMotivo(motivos){

            const motivoCadastrado = []

            motivos.map(motivo => {

                const motivoInserido = motivoCadastrado.find(u => u.id == motivo.id)

                if (!motivoInserido) {

                    motivoCadastrado.push({

                        id: motivo.id,
                        descricao: motivo.descricao,
                    })
                }
            })

            if (motivoCadastrado) {

                motivoCadastrado.sort((a,b) => (a.descricao > b.descricao) ? 1 : ((b.descricao > a.descricao) ? -1 : 0));
            }

            this.motivosAdicionados = motivoCadastrado

            let motivoSelecionado = this.motivosAdicionados.find(u => u.id == this.model.motivo)

            if (!motivoSelecionado) {

                this.model.motivo = null
            }
        },
        handlePeriodo() {

            this.model.veiculo = null
            this.model.municipio = null
            this.model.destino = null
            this.model.motivo = null
            this.loadFields()
        },
        search() {

            this.setLoading()
            this.repositories.relatorioQuantitativo.list(this.getSearchParams())
                .then(({ data }) => {

                    this.items = data.consulta
                    this.totalizadores = data.totalizadores
                 })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.periodo.start = null;
            this.model.periodo.end = null;
            this.model.veiculo = null;
            this.model.municipio = null;
            this.model.destino = null;
            this.model.motivo = null;
            this.items = [];
            this.veiculosAdicionados = [];
            this.municipiosAdicionados = [];
            this.destinosAdicionados = [];
            this.motivosAdicionados = [];
            this.totalizadores = [];
        },
        print() {
            this.setLoading()
            this.repositories.impressao.relatorioQuantitativo(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()
            this.repositories.exportacao.relatorioQuantitativo(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {
            const data = this.getSearchParams()
            data.selectedCols = this.fields.map(f => {
            return {
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class
                }
            })
            return data
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
    },
    mixins: [repository, error, data, object, stringCase, file],
    watch: {
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
        'model.periodo.start'() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'model.periodo.end'() {

           if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
    }
};
</script>
